// Kevora — scripts propios
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initFaq();
  initGallery();
  initVariantPicker();
  initCounters();
});

function initReveal() {
  var items = document.querySelectorAll('.kv-reveal');
  if (!items.length) return;
  if (!('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('kv-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('kv-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  items.forEach(function (el) { observer.observe(el); });
}

function initFaq() {
  var items = document.querySelectorAll('.kv-faq__item');
  items.forEach(function (item) {
    var btn = item.querySelector('.kv-faq__q');
    var answer = item.querySelector('.kv-faq__a');
    if (!btn || !answer) return;
    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('kv-open');
      items.forEach(function (other) {
        other.classList.remove('kv-open');
        var a = other.querySelector('.kv-faq__a');
        if (a) a.style.maxHeight = null;
      });
      if (!isOpen) {
        item.classList.add('kv-open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });
}

function initGallery() {
  var galleries = document.querySelectorAll('[data-kv-gallery]');
  galleries.forEach(function (gallery) {
    var main = gallery.querySelector('[data-kv-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-kv-gallery-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var type = thumb.getAttribute('data-type');
        var src = thumb.getAttribute('data-src');
        thumbs.forEach(function (t) { t.classList.remove('kv-active'); });
        thumb.classList.add('kv-active');
        if (type === 'video') {
          main.innerHTML = '<video src="' + src + '" autoplay muted loop playsinline controls></video>';
        } else {
          main.innerHTML = '<img src="' + src + '" alt="">';
        }
      });
    });
  });
}

function initVariantPicker() {
  var forms = document.querySelectorAll('[data-kv-product-form]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-kv-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var swatches = form.querySelectorAll('.kv-swatch');
    var idInput = form.querySelector('[data-kv-variant-id]');
    var priceEl = form.querySelector('[data-kv-price]');
    var compareEl = form.querySelector('[data-kv-compare]');
    var submitBtn = form.querySelector('[data-kv-submit]');

    function findVariant() {
      var selected = {};
      form.querySelectorAll('.kv-swatch.kv-active').forEach(function (s) {
        selected[s.getAttribute('data-option-name')] = s.getAttribute('data-option-value');
      });
      return variants.find(function (v) {
        return v.options.every(function (val, i) {
          var name = v.optionNames[i];
          return selected[name] === val;
        });
      });
    }

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        if (swatch.hasAttribute('disabled')) return;
        var group = swatch.getAttribute('data-option-name');
        form.querySelectorAll('.kv-swatch[data-option-name="' + group + '"]').forEach(function (s) {
          s.classList.remove('kv-active');
        });
        swatch.classList.add('kv-active');

        var variant = findVariant();
        if (!variant) return;
        if (idInput) idInput.value = variant.id;
        if (priceEl) priceEl.textContent = variant.priceFormatted;
        if (compareEl) {
          if (variant.compareAtPriceFormatted) {
            compareEl.textContent = variant.compareAtPriceFormatted;
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        if (submitBtn) {
          if (variant.available) {
            submitBtn.disabled = false;
            submitBtn.textContent = submitBtn.getAttribute('data-add-text');
          } else {
            submitBtn.disabled = true;
            submitBtn.textContent = submitBtn.getAttribute('data-soldout-text');
          }
        }
      });
    });
  });
}

function initCounters() {
  var counters = document.querySelectorAll('[data-kv-counter]');
  if (!counters.length || !('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      var el = entry.target;
      var target = parseFloat(el.getAttribute('data-kv-counter'));
      var suffix = el.getAttribute('data-suffix') || '';
      var duration = 1200;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var value = Math.floor(progress * target);
        el.textContent = value + suffix;
        if (progress < 1) requestAnimationFrame(step);
        else el.textContent = target + suffix;
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.4 });
  counters.forEach(function (el) { observer.observe(el); });
}
